<template>
  <div>
    <h2 class="ViewHeading">Clarence System Reports</h2>
    <div>
      <b-row>
        <b-col>
          <div>
            <b-card no-body>
              <b-tabs card>
                <b-tab title="Flows" active lazy>
                  <FlowReport @ReportLoad="ShowHideModal" />
                </b-tab>
                <b-tab title="Flush Tracking" lazy>
                  <FlushTrackReport @ReportLoad="ShowHideModal" />
                </b-tab>
                <!-- <b-tab title="Temperatures" lazy>
                  <TempReport @ReportLoad="ShowHideModal" />
                </b-tab> -->
                <b-tab title="High Risk" lazy>
                  <HighRiskReport @ReportLoad="ShowHideModal" />
                </b-tab>
                <b-tab title="Offline" lazy>
                  <OfflineReport @ReportLoad="ShowHideModal" />
                </b-tab>
                <b-tab title="Calibration" lazy>
                  <CalibrationReport @ReportLoad = "ShowHideModal" />
                </b-tab>
                <b-tab title="Commissioning" lazy>
                  <CommissionReport @ReportLoad = "ShowHideModal" />
                </b-tab>
              </b-tabs>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-modal
      ref="LoadingModal"
      id="LoadingModal"
      content-class="Modal"
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      centered
      hide-header
    >
    <div class="container_row" >
        <div class="layer2">
          <h1 class="HeadingText1">Loading Data...</h1>

          <img
            class="Logo"
            alt="Angelguard logo"
            src="../assets/LogoOnly.png"
          />
        </div>
    </div>
</b-modal>
  </div>
</template>

<script>
import FlowReport from "../components/ReportComponents/FlowReport.vue";
// import TempReport from "../components/ReportComponents/TempReport.vue";
import CalibrationReport from "../components/ReportComponents/CalibrationReport.vue";
import CommissionReport from "../components/ReportComponents/CommissionReport.vue";
import HighRiskReport from "../components/ReportComponents/HighRiskReport";
import OfflineReport from "../components/ReportComponents/OfflineReport";
import FlushTrackReport from "../components/ReportComponents/FlushTrackReport.vue";

export default {
  components: {
    FlowReport,
    // TempReport,
    CalibrationReport,
    CommissionReport,
    HighRiskReport,
    OfflineReport,
    FlushTrackReport,
  },
  computed: {},
  data() {
    return {};
  },
  mounted() {},

  methods: {
    ShowHideModal(Status) {
      if (Status == "Loaded") {
        this.$bvModal.hide("LoadingModal");
      } else if (Status == "Loading") {
        this.$bvModal.show("LoadingModal");
      }
    },
  },

  watch: {},
};
</script>

<style scoped>
.content {
    text-align: center;
  }
.layer1,
.layer2 {
  grid-column: 1;
  grid-row: 1;
  background-color: rgb(109, 136, 195);
  opacity: 0.5;
}
.layer1 span {
  display: grid;
  place-items: center;
}
.Logo {
  scale: 150%;
  margin-top: 5rem;
  width: 15%;
  min-width: 150px;
}
</style>
